<div class="form-header">
  <p>To enable ConnectWise Automate Integration with Identify, select the Enable Automate Integration below and follow the instructions.</p>
  <p *ngIf="!sessionService.hasRole(RoleType.ADMIN) && sessionService.isAccountType('SYSTEM')">
    Your role does not allow for saving settings changes on this screen.
  </p>
</div>
<form [formGroup]="verifyForm">
  <div class="formFieldList">
    <mat-form-field>
      <input tabindex="13" matInput formControlName="companySite" placeholder="ConnectWise Automate Server" required>
      <mat-error *ngIf="verifyForm.controls.companySite?.errors?.connectionError">Could not connect to your ConnectWise Automate server</mat-error>
      <mat-hint>e.g. https://yourname.hostedrmm.com</mat-hint>
    </mat-form-field>
    <mat-form-field>
      <input tabindex="15" matInput formControlName="username" placeholder="Username" required>
      <mat-error *ngIf="verifyForm.controls.username?.errors?.invalidPermissions">Permissions are not correct on this user</mat-error>
      <mat-error *ngIf="verifyForm.controls.username?.errors?.mfaRequired">User must be an integrator user (MFA disabled)</mat-error>
      <mat-error *ngIf="verifyForm.controls.username?.errors?.accountLocked">User account has been locked</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input tabindex="16" matInput formControlName="password" placeholder="Password" type="password" required>
    </mat-form-field>
    <mat-error *ngIf="verifyForm.errors?.failedAuth">Failed to authenticate with Automate. Please check your Username and Password.</mat-error>

    <button mat-button type="button" color="primary" [disabled]="!(verifyForm.dirty && verifyForm.valid)" (click)="verifyIntegration()">Verify Integration</button>
  </div>
</form>
<form [formGroup]="form">
  <div class="formFieldList">
    <div style='padding-bottom:20px;'>
      <mat-checkbox tabindex="12" formControlName="enableAutomate" (change)="onEnableChange()">Enable Automate Integration?</mat-checkbox>
    </div>
  
    <mat-form-field>
      <input type="text" matInput placeholder="Automate Client" formControlName="clientId" [matAutocomplete]="clients.auto">
      <cw-automate-client-dropdown #clients 
        (eventHandler)="handleEvent($event)"
        [searchControl]="form.controls.clientId"
        [partnerAccount]="account"
        [disableInUseClients]="true"></cw-automate-client-dropdown>
      <mat-error *ngIf="form.controls.clientId?.touched && !form.controls.clientId?.value">Please select a value from the dropdown</mat-error>
    </mat-form-field>
  </div>
</form>